import { render, staticRenderFns } from "./confirm-demo-booking.vue?vue&type=template&id=515350dd&scoped=true&"
import script from "./confirm-demo-booking.vue?vue&type=script&lang=js&"
export * from "./confirm-demo-booking.vue?vue&type=script&lang=js&"
import style0 from "./confirm-demo-booking.vue?vue&type=style&index=0&id=515350dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515350dd",
  null
  
)

export default component.exports